<template>
  <IndicatorWrapper class="tourists-ranking" :status="status" v-if="visible">
    <div class="top">
      <TextWithFilters
        ref="textComponent"
        textKey="tourists_ranking_text_with_filters"
        :textData="dynamicTextData"
        v-model="currentFilters"
      ></TextWithFilters>
    </div>
    <div class="bottom">
      <ValueBar :data="barValue" :status="status" :compareData="barValue2"></ValueBar>
      <LineChartTourists :status="evolutiveStatus" :data="indicatorData.evolutive" :compareData="indicatorData.compare_evolutive" :selected-item="currentFilters.nationality"></LineChartTourists>
      <ChartLegend :items="legendItems" v-show="isCompareMode" type="line"></ChartLegend>
      <ChartDescription :values="currentFilters" :indicator="indicator" descriptionKey="tourists_ranking_info"></ChartDescription>
    </div>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import indData from '@/mixins/indData'
import indDynamicText from '@/mixins/indDynamicText'
import TextWithFilters from '@/components/IndicatorCards/parts/TextWithFilters'
import ValueBar from '@/components/IndicatorCards/parts/charts/ValueBar'
import LineChartTourists from '@/components/IndicatorCards/parts/charts/LineChartTourists'
import ChartDescription from '@/components/IndicatorCards/parts/ChartDescription'
import ChartLegend from '@/components/IndicatorCards/parts/ChartLegend'
import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'


export default {
  name: 'TouristsRanking',
  components: {
    LineChartTourists,
    TextWithFilters,
    ValueBar,
    ChartDescription,
    IndicatorWrapper,
    ChartLegend
  },
  mixins: [indData, indDynamicText],
  computed: {
    evolutiveStatus () {
      // return (!this.indicatorData['evolutive'] || this.$asyncComputed['asc_evolutive'].updating) ? {status:'fetching'} : {status:'ready'}
      if(this.$asyncComputed['asc_evolutive'].updating) return {status:'fetching'}
      else if(!this.indicatorData['evolutive']) return {status:'no-data'}
      else return {status:'ready'}
    },
    indicatorData() {
      return {
        main_value: {
          required: true,
          get () {
            return Api.getIndicatorData('ind_tourism_ranking', this.currentFilters)
          }
        },
        evolutive: {
          required: false,
          get () {
            return Api.getIndicatorData('evol_tourism_ranking_month', this.currentFilters)
          }
        },
        compare_data: {
          required: false,
          triggers_jump: false,
          get () {
            return this.isCompareMode ? Api.getIndicatorData('ind_tourism_ranking',this.currentFilters, {
              node: this.compareNodeInfo,
              avoidCancel: true
            }) :
            Promise.resolve(false)
          }
        },
        compare_evolutive: {
          required: false,
          triggers_jump: false,
          get () {
            return this.isCompareMode ? Api.getIndicatorData('evol_tourism_ranking_month',this.currentFilters, {
              node: this.compareNodeInfo,
              avoidCancel: true
            }) :
            Promise.resolve(false)
          }
        }
      }
    },
    dynamicTextData() {
      return [
        {
          type: 'select',
          id: 'timeScale',
        },
        {
          type: 'select',
          id: 'nationality',
        },
        {
          type: 'value',
          id: 'VALUE_1',
          value: this.barValue && this.barValue.value,
          unit: '%'
        }
      ]
    },

    barValue () {
      return this.indicatorData.main_value && this.indicatorData.main_value.data[0]
    },
    barValue2 () {
      return this.indicatorData.compare_data && this.indicatorData.compare_data.data[0]
    }
  },

}
</script>

<style lang="stylus" scoped>
.tourists-ranking
  .desktop &
    .bottom
      margin-top: vh(-50px)
    .value-bar
      margin vh(20px) vw(10px) vh(20px) vw(5px)
      flex 0 0 vh(80px)
    .ranking-chart
      margin auto 0px
      flex 1 0 vh(420px)
  .mobile &
    .value-bar
      margin vh(20px) vw(10px) vh(20px) vw(5px)
      flex 0 0 vh(100px)
    .ranking-chart
      margin auto 0px
      flex 1 0 vh(420px)
  

</style>